import { type App } from 'vue';
import { type Router } from 'vue-router';
import { setSentryUser, setupSentry } from '@/plugins/sentry';

const isSentryEnabled = Boolean(import.meta.env.VITE_DSN);

export const setupObservability = (app: App, router: Router) => {
  if (isSentryEnabled) {
    setupSentry(app, router);
  } else {
    app.config.errorHandler = (err, _instance, info) => {
      console.error('[Vue error]', err, info);
    };
  }
};

export const setObservabilityUser = (email: string) => {
  if (isSentryEnabled) {
    setSentryUser(email);
  }
};
